/* eslint-disable */
export default class Format {
}

Format.NEW_LINE = '\n\n';
Format.NEXT_LINE = '\n';
Format.DOUBLE_QUOTES = '\"';
Format.TAB = '\t';
Format.SEMICOLON = ';';



// WEBPACK FOOTER //
// ./src/framework/Format.js